/**
 * True when `name` is only the email local-part (e.g. shefali.chaudhary), not a registered full name.
 */
export function isEmailLocalPartAlias(name, email) {
  const n = String(name || '').trim();
  if (!n || !email) return false;
  const local = String(email).split('@')[0]?.trim().toLowerCase();
  if (!local) return false;
  const normalizedName = n.replace(/\s+/g, '').toLowerCase();
  const normalizedLocal = local.replace(/\./g, '').toLowerCase();
  return normalizedName === normalizedLocal || normalizedName === local;
}

/**
 * Preferred name for certificates, profile header, and exports.
 * Uses Firebase-registered display name; does not fall back to email local-part.
 */
export function resolveParticipantDisplayName({
  displayNameRaw,
  displayName,
  email,
  fallbackLabel = 'Participant',
}) {
  const raw = String(displayNameRaw ?? '').trim();
  if (raw && !isEmailLocalPartAlias(raw, email)) return raw;

  const dn = String(displayName ?? '').trim();
  if (dn && !isEmailLocalPartAlias(dn, email)) return dn;

  return String(fallbackLabel || 'Participant').trim() || 'Participant';
}
